import React, { useState, useMemo, useEffect, useContext } from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../../internal/ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import { Add } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ReactDOM from 'react-dom';
import DialogComp from '../../../../Core/Modal/dialogModal';
import CashAccountModal from './CashAccountModal';
import AppContext from '../../../../App/AppContext';
import ConfirmationModal from '../../../../Core/Controls/Dialog/ConfirmationModal';
import { getTCardsCashAccounts, deleteTCardsCashAccounts } from '../../../../Core/Service/TCard-CashAccounts-service';

let styleObj = {
    backgroundColor: '#183B68',
    borderRadius: '20%',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    padding: '0px 0px 0px 0px'
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'T-card', active: true },
    { name: 'Cash Accounts', active: true }
];

const TCardCashAccounts = () => {
    const { showToast } = useContext(AppContext);
    const [state, setState] = useState({
        isReload: new Date(),
        cashAccountID: null,
        cashAccountBranchID: null,
        cashAccountCode: null,
        showModal: false,
        showConfirmModal: false,
        deleteRecord: null,
        rows: []
    });

    const fetchCashAccounts = async () => {
        try {
            const res = await getTCardsCashAccounts();
            if (res?.data?.list) {
                setState((st) => ({
                    ...st,
                    rows: res.data.list
                }));
            }
        } catch (error) {
            console.error('Failed to fetch cash accounts:', error);
        }
    };

    useEffect(() => {
        fetchCashAccounts();
    }, [state.isReload]);

    const handleClose = (shouldReload) => {
        setState((st) => ({
            ...st,
            showModal: false,
            cashAccountID: null,
            cashAccountBranchID: null,
            cashAccountCode: null,
            isReload: shouldReload ? new Date() : st.isReload
        }));
    };

    const handleConfirmClose = (shouldReload = false) => {
        setState((st) => ({
            ...st,
            showConfirmModal: false,
            deleteRecord: null,
            isReload: shouldReload ? new Date() : st.isReload
        }));
    };

    const baseColumns = [
        {
            field: 'action',
            title: `Action`,
            filterable: false,
            sortable: false,
            width: '3%'
        },
        {
            field: 'cashAccountCode',
            sortable: true,
            filterable: true,
            title: `Cash Account Code`,
            width: '20%'
        },
        {
            field: 'branch',
            sortable: true,
            filterable: true,
            title: `Branch`,
            width: '20%'
        }
    ];

    const handelAddUpdate = (row = null) => {
        setState((st) => ({
            ...st,
            showModal: true,
            cashAccountID: row?.cashAccountID || null,
            cashAccountBranchID: row?.cashAccountBranchID || null,
            cashAccountCode: row?.cashAccountCode || null
        }));
    };

    const handleDelete = (record) => {
        setState((st) => ({
            ...st,
            showConfirmModal: true,
            deleteRecord: record
        }));
    };

    const handleDeleteConfirmed = async () => {
        const rec = state.deleteRecord;
        if (!rec) return;

        try {
            const res = await deleteTCardsCashAccounts(rec.cashAccountID);
            if (res.success) {
                showToast('Cash Account deleted successfully');
                setState((st) => ({
                    ...st,
                    showConfirmModal: false,
                    deleteRecord: null,
                    isReload: new Date()
                }));
            } else {
                showToast(res.message || 'Delete failed', 'error');
                setState((st) => ({
                    ...st,
                    showConfirmModal: false,
                    deleteRecord: null
                }));
            }
        } catch (err) {
            console.error('Delete error:', err);
            showToast(err.response?.data || err.message || 'Error deleting', 'error');
            setState((st) => ({
                ...st,
                showConfirmModal: false,
                deleteRecord: null
            }));
        }
    };

    const addButton = () => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ marginLeft: '5px' }}>
                <Tooltip title="Add Cash Account" arrow>
                    <abbr style={{ textDecoration: 'none' }}>
                        <SquareButton style={styleObj} onClick={() => handelAddUpdate(null)}>
                            <Add fontSize="small" style={{ color: 'white' }} />
                        </SquareButton>
                    </abbr>
                </Tooltip>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editButton = () => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-evenly">
                <Tooltip title="Edit Cash Account" arrow>
                    <abbr style={{ textDecoration: 'none' }}>
                        <SquareButton style={styleObj} onClick={() => handelAddUpdate(record)}>
                            <EditIcon fontSize="small" style={{ color: 'white' }} />
                        </SquareButton>
                    </abbr>
                </Tooltip>
                <Tooltip title="Delete Cash Account" arrow>
                    <abbr style={{ textDecoration: 'none' }}>
                        <SquareButton style={{ ...styleObj, backgroundColor: '#dc3545' }} onClick={() => handleDelete(record)}>
                            <DeleteIcon fontSize="small" style={{ color: 'white' }} />
                        </SquareButton>
                    </abbr>
                </Tooltip>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');

        if (actionCol) {
            actionCol.renderer = editButton({});
        }

        return tempCols;
    }, []);

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ReportGijgoGrid columns={columns} isReload={state.isReload} AddBtn={addButton} localRowsData={state.rows} />
                </Grid>
            </Grid>

            {/* Add/Edit Modal */}
            {state.showModal && (
                <DialogComp
                    overflow="auto"
                    title={state.cashAccountBranchID ? 'Update Cash Account' : 'Add Cash Account'}
                    fullWidth
                    onClose={() => handleClose(false)}
                >
                    <CashAccountModal
                        onClose={() => handleClose(true)}
                        cashAccountID={state.cashAccountID}
                        cashAccountBranchID={state.cashAccountBranchID}
                        cashAccountCode={state.cashAccountCode}
                    />
                </DialogComp>
            )}

            {state.showConfirmModal && (
                <DialogComp title="Confirm Delete" maxWidth="sm" onClose={() => handleConfirmClose()}>
                    <ConfirmationModal
                        message={`Are you sure you want to delete cash account code ${state.deleteRecord.cashAccountCode} for branch ${state.deleteRecord.branch}?`}
                        handleSubmit={handleDeleteConfirmed}
                        handleCancel={() => handleConfirmClose()}
                    />
                </DialogComp>
            )}
        </div>
    );
};

export default TCardCashAccounts;
